import { useMemo } from 'react'

import { useTypedSelector } from '../../'
import { buildTaskDelayVM } from '../../reducers/delayNotificationViewModel'
import { Task } from '../../types'
import DelayNotificationBar from '../notification/DelayNotificationBar'

type Props = {
  task: Task
  router: { push: (path: string) => void }
}

/**
 * Per-task delay notification for the current shift. All show/hide and content
 * decisions live in buildTaskDelayVM; this component only maps the view model
 * to markup.
 */
const TaskDelayNotification = ({ task, router }: Props) => {
  const isDriver = useTypedSelector((state) => state.user.driver)
  const punctualityByTrain = useTypedSelector((state) => state.punctuality.punctualityByTrain)

  const vm = useMemo(
    () => buildTaskDelayVM({ isDriver, punctualityByTrain }, task),
    [isDriver, punctualityByTrain, task]
  )

  if (!vm) return null

  return (
    <DelayNotificationBar
      notificationKey={vm.notificationKey}
      initialStep="wasDelayDueToEquipmentFault"
      onAmendment={() => router.push(vm.amendmentPath)}
    />
  )
}

TaskDelayNotification.displayName = 'TaskDelayNotification'

export default TaskDelayNotification
